import React, { useState } from 'react';
import Dropzone from 'react-dropzone';
import { ReactSortable } from 'react-sortablejs';

import { bytesToSize } from '../../../helpers/general';

import csvIcon from '../../../assets/icons/file_icons/csv.png';
import jpgIcon from '../../../assets/icons/file_icons/jpg.png';
import pdfIcon from '../../../assets/icons/file_icons/pdf.png';
import pngIcon from '../../../assets/icons/file_icons/png.png';
import { config } from '../../../config';
const { SERVER_URL } = config;

const Upload = ({
  files,
  setFiles,
  multiple = true,
  accept = 'audio/*, video/*, image/*, application/*',
  sort = false,
}) => {
  const handleAccept = (files) => setFiles((prev) => {
    files.push(...prev);
    return files;
  });

  const handleReject = (event) => {};

  const sortableOptions = {
    animation: 150,
    fallbackOnBody: true,
    swapThreshold: 0.65,
    ghostClass: 'ghost',
    group: 'shared',
    forceFallback: true,
  };

  return (
    <React.Fragment>
      {files && files.length > 0 ? (
        sort ? (
          <>
          <ReactSortable
            list={files}
            setList={setFiles}
            className="d-flex w-100 flex-column "
            {...sortableOptions}
            style={{ userSelect: 'none' }}
          >
            {files.map((file, index) => (
              <div
                key={index}
                className="d-flex justify-content-between align-items-center border rounded"
                style={{
                  cursor: 'move',
                  padding: '14px 14px 14px 25px',
                  marginBottom: 6,
                  position: 'relative',
                }}
              >
                {!file.new_image ? (
                  <div className="d-flex w-100 flex-row justify-content-between align-items-center ">
                    {file.type === 'image/jpeg' || file.type === 'image/jpg' ? (
                      <img
                        src={URL.createObjectURL(file)}
                        style={{ height: '30px' }}
                        alt=""
                      />
                    ) : file.type === 'image/png' ? (
                      <img
                        src={URL.createObjectURL(file)}
                        style={{ height: '30px' }}
                        alt=""
                      />
                    ) : file.type === 'application/pdf' ? (
                      <img src={pdfIcon} style={{ width: '30px' }} alt="" />
                    ) : (
                      ''
                    )}
                    <div className="d-flex flex-column flex-grow-1 ms-4">
                      <div>{file.name}</div>
                      <small className="text-muted">
                        {bytesToSize(file.size)}
                      </small>
                    </div>
                  </div>
                ) : (
                  <div className="d-flex w-100 flex-row justify-content-between align-items-center ">
                    {
                      <img
                        src={`${SERVER_URL}/${file.new_image}`}
                        style={{ height: '30px' }}
                        alt=""
                      />
                    }
                    <div className="d-flex flex-column flex-grow-1 ms-4">
                      <div>{file.orig_image}</div>
                      <small className="text-muted"></small>
                    </div>
                  </div>
                )}
                <i
                  className="fas fa-times"
                  onClick={() => {
                    setFiles(files.filter((file, i) => i !== index));
                  }}
                  style={{ cursor: 'pointer' }}
                />
                <div
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 5,
                    fontSize: 11,
                    fontWeight: 700,
                    color: '#86929c',
                  }}
                >
                  {index}
                </div>
              </div>
            ))}
          </ReactSortable>

          <Dropzone
            multiple={multiple}
            onDrop={handleAccept}
            onRejected={(event) => handleReject(event)}
            accept={accept}
          >
            {({ getRootProps, getInputProps }) => (
              <div
                {...getRootProps({
                  className:
                    'd-flex w-100 flex-column justify-content-center align-items-center rounded text-center p-4',
                  style: { border: '2px dashed #e3e3e3' },
                })}
              >
                <input {...getInputProps()} />
                <i className="fas fa-upload fa-3x text-brand"></i>
                <p className="pt-3">You can also upload files by</p>
                <p className="text-brand">Clicking here</p>
              </div>
            )}
          </Dropzone>
        </>
        ) : (
          <div
            className="d-flex w-100 flex-column border rounded px-4 py-2"
            style={{ backgroundColor: 'inherit' }}
          >
            {files.map((file, index) => (
              <div
                key={index}
                className="d-flex justify-content-between align-items-center"
              >
                <div className="d-flex w-100 flex-row justify-content-between align-items-center py-2">
                  {file.type === 'image/jpeg' || file.type === 'image/jpg' ? (
                    <img src={jpgIcon} style={{ width: '30px' }} alt="" />
                  ) : file.type === 'image/png' ? (
                    <img src={pngIcon} style={{ width: '30px' }} alt="" />
                  ) : file.type === 'application/pdf' ? (
                    <img src={pdfIcon} style={{ width: '30px' }} alt="" />
                  ) : (
                    ''
                  )}
                  <div className="d-flex flex-column flex-grow-1 ms-4">
                    <div>{file.name}</div>
                    <small className="text-muted">
                      {bytesToSize(file.size)}
                    </small>
                  </div>
                </div>
                <i
                  className="fas fa-times"
                  onClick={() => {
                    setFiles(files.filter((file, i) => i !== index));
                  }}
                  style={{ cursor: 'pointer' }}
                />
              </div>
            ))}
          </div>
        )
      ) : (
        <Dropzone
          multiple={multiple}
          onDrop={handleAccept}
          onRejected={(event) => handleReject(event)}
          accept={accept}
        >
          {({ getRootProps, getInputProps }) => (
            <div
              {...getRootProps({
                className:
                  'd-flex w-100 flex-column justify-content-center align-items-center rounded text-center p-4',
                style: { border: '2px dashed #e3e3e3' },
              })}
            >
              <input {...getInputProps()} />
              <i className="fas fa-upload fa-3x text-brand"></i>
              <p className="pt-3">You can also upload files by</p>
              <p className="text-brand">Clicking here</p>
            </div>
          )}
        </Dropzone>
      )}
    </React.Fragment>
  );
};

export default Upload;
